import { combineReducers } from 'redux';
import { localeReducer as locale } from 'react-localize-redux';
import users from './UserReducer';
import masterData from './MasterDataReducer';

export default combineReducers({
  locale,
  users,
  masterData
});



// WEBPACK FOOTER //
// ./reducers/index.js